import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "../../Modal";
import { List } from "../../../ui";
import { useDialogProps } from "../../../hooks";
export const DocumentsListDialog = () => {
    const [{ data }] = useDialogProps();
    return (_jsx(Modal, { title: "\u0421\u043F\u0438\u0441\u043E\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432", content: data && (_jsx(List, { icon: "document", children: data.map((document, documentIndex) => (_jsx("li", { children: document }, `documents-list-item-${documentIndex}`))) })) }));
};
